
import scrollToListTop from '@/mixins/scrollToListTop'
import queryParams from '~/mixins/queryParams'
import hasModel from '~/mixins/hasModel'

export default {
    mixins: [queryParams, hasModel, scrollToListTop],

    props: {
        viewAll: {
            type: Boolean,
            default: true,
        },
        viewAllTarget: {
            type: String,
            default: undefined,
        },
        content: {
            type: Array,
            default: () => [],
        },
        titleCenter: Boolean,

        columnClass: {
            type: String,
            default: '',
        },
    },

    async fetch() {
        const filters = {
            'order-dir': 'desc',
            'order-by': 'updated_at',
        }
        let response = {}
        if (this.model.contentType === 'files')
            response = await this.$axios.$get('/api/v1/exclusive_files', {
                params: {
                    ...filters,
                    ...this.model.apiQuery,
                    status: 'published',
                },
            })
        else
            response = await this.$axios.$get('/api/v1/content/list', {
                params: {
                    ...filters,
                    content_type: this.model.contentType,
                    per_page: this.model.per_page || 4,
                    exclude_id: this.model.exclude_id || undefined,
                    page: 1,
                    id: this.content?.length ? this.content : undefined,
                    is_randomized: false,
                    ...this.model.apiQuery,
                },
            })
        this.$set(this, 'list', response.data)
    },

    data() {
        return {
            list: [],
        }
    },

    computed: {
        smDevice(){
            return this.$store.getters['data/smDevice']
        },
        mappedList() {
            return this.list.map((el) => {
                return {
                    src: el.cover.url,
                    id: el.id,
                    slug: el.slug,
                    name: el.name,
                }
            })
        },

        isPlanningList() {
            return !['real-weddings', 'wedding-inspiration', 'vendors'].includes(this.model.contentType)
        },

        computedClass() {
            return this.columnClass ? this.columnClass : this.isPlanningList ? 'xl:grid-cols-4 sm:grid-cols-2' : 'md:grid-cols-4'
        },
        componentType(){
            switch(this.model.contentType) {
                case 'real-weddings':
                    return {
                        component: 'loverly-v2-content-item-real-wedding',
                    }
                case 'wedding-inspiration':
                    return {
                        component: 'loverly-inspiration-item',
                        collection: this.mappedList
                    }
                case 'vendors':
                    return {
                        component: 'loverly-v2-content-item-vendor',
                    }
                case 'brand':
                    return {
                        component: 'loverly-v2-content-item-brand',
                        logo: true
                    }
                case 'videos':
                    return {
                        component: 'loverly-v2-content-item-video'
                    }
                case 'files':
                    return {
                        component: 'loverly-v2-content-item-download',
                        disabled: false
                    }
                case 'shop':
                case 'products':
                    return {
                        component: 'loverly-v2-content-item-product',
                    }
                default:
                    return {
                        component: 'loverly-v2-content-item-article',
                    }
            }
        }
    },

    methods: {
        redirect() {
            if (this.viewAllTarget) return this.$router.push(this.viewAllTarget)
            else this.$router.push({ query: this.model.queryObject, params: this.model.paramsObject || {}, name: this.model.route || this.$route.name })
            this.scrollToTop()
        },
    },
}
